/** Browser `accept` for meeting prep uploads (server may still process a subset). */
export const MEETING_DOCUMENT_ACCEPT =
  '.pdf,.doc,.docx,.ppt,.pptx,.txt,.md,.csv,.rtf,.odt,.odp,' +
  'application/pdf,application/msword,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.ms-powerpoint,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
  'text/plain,text/markdown,text/csv'

export const MEETING_DOCUMENT_FORMATS_HINT =
  'PDF, Word, PowerPoint, and text files (.pdf, .docx, .pptx, .txt, .md, .csv, and more)'
